import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import E12Spinner from '@/components/E12Spinner';

export default function PublicRoute() {
  const { status, checkAuth } = useAuthStore();

  useEffect(() => {
    if (status === 'idle') {
      checkAuth();
    }
  }, [status, checkAuth]);

  if (status === 'loading' || status === 'idle') {
    return <E12Spinner />;
  }

  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
